import Resizable from '@corvu/resizable';
import { Icon } from '@tcweb/connect-ui';
import { t } from '@trimble/i18n';
import { Component, Show } from 'solid-js';

import { FxWorkspacesSelectionTreeContainer } from '../selections/tree/FxWorkspacesSelectionTreeContainer';
import { DraftLayersPanel } from './DraftLayersPanel';
import { FxWorkspaceEmptyState } from './FxWorkspaceEmptyState';
import { WorkspaceEmptyReferences } from './WorkspaceEmptyReferences';
import type { WorkspacesTabActiveWorkspaceProps } from './WorkspacesTabActiveWorkspace.types';

export const WorkspacesTabActiveWorkspace: Component<
  WorkspacesTabActiveWorkspaceProps
> = (props) => (
  <div class="h-full min-h-0">
    <Resizable orientation="vertical" class="h-full w-full">
      <Resizable.Panel
        initialSize={0.55}
        minSize={0.4}
        class="min-h-0 overflow-auto"
      >
        <Show
          when={props.hasWorkspaceReferences}
          fallback={<WorkspaceEmptyReferences />}
        >
          <Show
            when={props.nodes.length > 0}
            fallback={
              <FxWorkspaceEmptyState
                icon="tc-icon-folder"
                title={t(
                  'mobileMapping.fxWorkspace.references.noMatches.title'
                )}
                message={t(
                  'mobileMapping.fxWorkspace.references.noMatches.message'
                )}
                dataTestId="workspace-references-no-matches"
              />
            }
          >
            <FxWorkspacesSelectionTreeContainer
              nodes={props.nodes}
              childrenLoadStatus={props.childrenLoadStatus}
              filterKey={props.workspace.id}
              sortBy="label"
              sortDirection="asc"
            />
          </Show>
        </Show>
      </Resizable.Panel>
      <Resizable.Handle
        aria-label={t('mobileMapping.fxWorkspace.draftLayers.resizeHandle')}
        class="group basis-4 flex items-center justify-center cursor-row-resize select-none text-icon-secondary hover:bg-base-200 corvu-group-active:bg-base-200 corvu-group-dragging:bg-base-200 transition-colors"
      >
        <Icon icon="tc-icon-drag-horiz" size="icon-small" />
      </Resizable.Handle>
      <Resizable.Panel
        initialSize={0.45}
        minSize={0.15}
        class="min-h-0 overflow-hidden"
      >
        <DraftLayersPanel workspaceId={props.workspace.id} />
      </Resizable.Panel>
    </Resizable>
  </div>
);
